<template>
  <div class="menu-row" id="top">
    <div class="menu-item" v-for="(m, k) in menu" :key="k">
      <link-to v-if="!m.url" :to="m.link">{{m.name}}</link-to>
      <a v-if="m.url" :href="m.url" target="_blank">{{m.name}}</a>
    </div>



    <!-- <div class="menu-item--right" v-if="toppromo">
    <a class="menu-item--button" :href="toppromo.link" target="_blank">{{toppromo.title}}</a>
    <span class="menu-item--text">{{toppromo.description}}</span>
    </div>

-->

    <div class="menu-item--right">
      <a :class="{'menu-item--button' : true, 'hovered' : entranceDesktopHovered}" href="https://online.russoutdoor.ru/" target="_blank">Вход</a>
<!--      <a :class="{'menu-item&#45;&#45;button' : true, 'hovered' : entranceDesktopHovered}" v-click-outside="entranceCloseOutside" @click="EntranceClick" >Вход</a>
      <ul v-if="entranceShow" class="menu-item&#45;&#45;list">
        <li>
          <a href="http://agency.russoutdoor.ru/?type=dsp">DSP</a>
          <span>Programmatic-закупка свободного цифрового рекламного инвентаря</span>
        </li>
        <li>
          <a href="http://agency.russoutdoor.ru/?type=agency">Агентствам</a>
          <span>Профессиональный инструмент для планирования и проведения кампаний на digital конструкциях</span>
        </li>
        <li>
          <a href="https://online.russoutdoor.ru/login">Рекламодателям</a>
          <span>Самостоятельная покупка и управление рекламными кампаниями</span>
        </li>
        <li>
          <a href="http://agency.russoutdoor.ru/?type=partners">Партнерам</a>
          <span>Подключение и управление рекламным инвентарем для партнеров-операторов</span>
        </li>
      </ul>-->
      <span class="menu-item--text" >{{toppromo.description}}</span>
    </div>

  </div>

</template>

<script>
  import RouteMixin from "../shared/mixins/RouteMixin";

  export default {
    mixins: [RouteMixin],
    // async asyncData({ $axios, route, redirect, store, query }) {
    //    await this.$store.dispatch('menu/loadMenu', 'top');
    // },
    computed: {
      entranceShow(){
        return this.$store.state.menu.entranceButton;
      },
      entranceDesktopHovered(){
        return this.$store.state.menu.entranceButton && !this.$store.state.menu.mobileMenuOpen;
      },
      menu() {
        return this.$store.state.menu.menuItems.top.loaded ? this.$store.state.menu.menuItems.top.items: [];
      },
      toppromo(){
        let menuItem = false;
        if(this.$store.state.menu.menuItems.toppromo.loaded) {
          let menuItems = this.$store.state.menu.menuItems.toppromo.items;
          for(let k in menuItems) {
            if(menuItems.hasOwnProperty(k)) {
              if(menuItems[k].hasOwnProperty('id') && menuItems[k].id == 7100) {
                menuItem = menuItems[k];
                break;
              }
            }
          }
          return menuItem
        }
        return this.$store.state.menu.menuItems.toppromo.loaded ? this.$store.state.menu.menuItems.toppromo.items[0]: [];
      },
      seo() {
        const  top = this.$store.state.menu.menuItems.top.loaded ? this.$store.state.menu.menuItems.top.items: [];
        const  btm = this.$store.state.menu.menuItems.btm.loaded  ? this.$store.state.menu.menuItems.btm.items.filter((item)=>item.id === 1500) : [];
        return [...new Set([...top, ...btm])];
      },
    },
    mounted() {
      this.$store.dispatch('menu/loadMenu', 'top');
      this.$store.dispatch('menu/loadMenu', 'toppromo');
    },
    methods: {
      entranceCloseOutside(event){
        if(this.$store.state.menu.entranceButton && !this.$store.state.menu.mobileMenuOpen) {
          let entranceBlock = document.getElementsByClassName('menu-item--right')[0];
          if (event.target !== entranceBlock && !entranceBlock.contains(event.target)) {
            this.$store.state.menu.entranceButton  = !(this.$store.state.menu.entranceButton && !this.$store.state.menu.mobileMenuOpen);
          }
        }

      },
      EntranceClick(){
        this.$store.state.menu.entranceButton = !this.$store.state.menu.entranceButton;
        console.log( this.$store.state.menu.entranceButton);
      }
    },
    directives: {
      "click-outside": {
        bind: function (el, binding, vnode) {
          el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
              // and if it did, call method provided in attribute value
              vnode.context[binding.expression](event);
            }
          };
          document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind: function (el) {
          document.body.removeEventListener('click', el.clickOutsideEvent)
        },
      }
    },
    watch: {
      seo(menuItem) {
        if(menuItem && menuItem.length) {
          const url = this.urlParentSub(this.$route.path) || null;
          const link = this.urlParent(this.$route.path);
          let value = null;
          const currentMenu = menuItem.find((i)=>i.link === link);
          if (currentMenu && currentMenu.items && currentMenu.items.length) {
            value = currentMenu.items.find((i)=>i.link === url)
          }else{
            value = currentMenu;
          }
          this.$emit('currentMenu', value);
        }
      }
    }
  };
</script>




// WEBPACK FOOTER //
// components/header/Menu.vue